import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import ReturnSellingActions from "../../../../reducers/modules/sales/return-selling/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/return-selling";

export default class ReturnSellingMiddleware {
  static newBackWarehouse(params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.newBackWarehouse());
      ReturnSellingMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveWarehouse(params, post, search) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.submit());
      ReturnSellingMiddleware.saveWarehouse(dispatch, params, post, search);
    };
  }

  static saveWarehouse(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, search));
            dispatch(ReturnSellingActions.success());
            ReturnSellingMiddleware.alertHendler(
              dispatch,
              response,
              true,
              "Save Data Successfully",
              "success"
            );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }




  static create() {
    return (dispatch) => {
      dispatch(ReturnSellingActions.create());
    };
  }

  static update(params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.update());
      ReturnSellingMiddleware.showOne(dispatch, params);
    };
  }

  static beforeApprove(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(ReturnSellingActions.approve());
      ReturnSellingMiddleware.saveApprove(dispatch, post, search);
    };
  }

  static beforeReject(id, value, search) {
    const post = {
      id: id,
      value: value,
    };
    return (dispatch) => {
      dispatch(ReturnSellingActions.reject());
      ReturnSellingMiddleware.saveReject(dispatch, post, search);
    };
  }

  static list(params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.process());
      ReturnSellingMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(ReturnSellingActions.reset());
    };
  }
  static resetList() {
    return (dispatch) => {
      dispatch(ReturnSellingActions.resetList());
    };
  }
  static getOne(params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.view());
      ReturnSellingMiddleware.showOne(dispatch, params);
    };
  }

  static beforeSaveNew(post, search) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.submit());
      ReturnSellingMiddleware.saveNew(dispatch, post, search);
    };
  }
  static beforeSaveUpdate(params, post, search) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.submit());
      ReturnSellingMiddleware.saveUpdate(dispatch, params, post, search);
    };
  }

  static getPrint(params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.beforePrint());
      ReturnSellingMiddleware.showPrint(dispatch, params);
    };
  }

  static beforeDelete(id, params) {
    return (dispatch) => {
      dispatch(ReturnSellingActions.delete());
      ReturnSellingMiddleware.delete(dispatch, params, id);
    };
  }

  static getHelper(params = null) {
    return (dispatch) => {
      ReturnSellingMiddleware.showHelper(dispatch, params);
    };
  }

  static getHelperFull(params = null) {
    return (dispatch) => {
      ReturnSellingMiddleware.showHelperFull(dispatch, params);
    };
  }

  static getToken() {
    return cookieManager.getUserToken();
  }

  static saveApprove(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/approve/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnSellingActions.success());
          ReturnSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Approve Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveReject(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/reject/" + post.id,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnSellingActions.success());
          ReturnSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reject Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showHelperFull(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-helper-return-selling",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnSellingActions.helperFull(response.data.result));
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnSellingActions.list(response.data.result));
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showHelper(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: process.env.REST_URL + "helper/get-return-Selling",
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnSellingActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static showPrint(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/print/" + params,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnSellingActions.print(response.data.result));
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      responseType: "json",
    })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(ReturnSellingActions.view(response.data.result));
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static delete(dispatch, params, id) {
    axios({
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/" + id,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, params)
          );
          ReturnSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Delete Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static saveNew(dispatch, post, search) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, search)
          );
          dispatch(ReturnSellingActions.success());
          ReturnSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Create Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }

  static saveUpdate(dispatch, params, post, search) {
    axios({
      method: "PUT",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${ReturnSellingMiddleware.getToken()}`,
      },
      url: url + "/" + params,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            ReturnSellingActions.process(),
            ReturnSellingMiddleware.showlist(dispatch, search));
          dispatch(ReturnSellingActions.success());
          ReturnSellingMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Update Data Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        ReturnSellingMiddleware.alertHendler(dispatch, error);
      });
  }
  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Delete Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
            } else {
              const data = result.response.data;
              dispatch(ReturnSellingActions.error(data.error));
            }
            break;
          case 403:
            console.log("Error 403");
            break;
          case 404:
            console.log("Error 404");
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(ReturnSellingActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
